import { render } from "./Main.view.vue?vue&type=template&id=7b38162a"
import script from "./Main.view.vue?vue&type=script&lang=js"
export * from "./Main.view.vue?vue&type=script&lang=js"

import "./Main.view.vue?vue&type=style&index=0&id=7b38162a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__